export default __webpack_public_path__ + "static/media/tuhfahReview.37817349.png";